import { Inject, Injectable } from "@angular/core";
import { AbstractService } from "./abstract-service.service";
import { ContactInformations } from "../Models/Contact-informations";
import { HttpClient } from "@angular/common/http";
import { APP_CONFIG, AppConfig } from "./config";
import { Observable } from "rxjs";
import { Response } from "../Models/response";
import { map } from "rxjs/operators";

@Injectable({
  providedIn: "root",
})
export class ContactInformationsService extends AbstractService<
  ContactInformations,
  number
> {
  url: string;
  constructor(http: HttpClient, @Inject(APP_CONFIG) config: AppConfig) {
    super(http);
    this.url = config.apiEndpoint.concat("/new/contact-info");
  }
  public getContactInformations(): Observable<ContactInformations> {
    const url = `${this.url}`;
    return this.http.get<ContactInformations>(url).pipe(
      map((response: ContactInformations) => {
        if (response) {
          return response;
        } else {
          throw new Error();
        }
      })
    );
  }
}
